import React, { useState } from 'react';
import DirectoryCard from '../DirectoryCard';
import { setDoc, collection, doc } from 'firebase/firestore';
import { db } from '../../../firebase';

const toTitleCase = (str) =>
	str
		.trim()
		.toLowerCase()
		.replace(/\b\w/g, (c) => c.toUpperCase());

const NewFolderInput = ({ fetchDirectories, organizationId, hideNewFolderInput }) => {
	const [folderName, setFolderName] = useState('');

	const handleNameChange = (name) => {
		setFolderName(name);
	};

	const onAddClick = async () => {
		if (!folderName.trim()) {
			hideNewFolderInput();
			return;
		}

		const directory = {
			name: toTitleCase(folderName),
			organizationId,
			projects: [],
			subDirectories: [],
		};

		await addDirectory(directory);
		hideNewFolderInput();
	};

	const addDirectory = async (directory) => {
		try {
			const directoriesCollectionRef = collection(db, 'organizations', organizationId, 'directories');
			await setDoc(doc(directoriesCollectionRef), directory);
			fetchDirectories();
		} catch (error) {
			console.error('Error adding document: ', error);
		}
	};

	return (
		<DirectoryCard
			directory={{ name: folderName }}
			inAddMode={true}
			onNameChange={handleNameChange}
			onSubmit={onAddClick}
			onCancel={hideNewFolderInput}
		/>
	);
};

export default NewFolderInput;
